import { sendRequestProtocols } from '../axios';
import { sendRequest } from './../axios';

export default {
  state: {
    processing: false,
    error: null,
    debug: true,
    banksList: [],
    banksListLoading: false
  },
  mutations: {
    SET_DEBUG(state, payload) {
      state.debug = payload
    },
    SET_PROCESSING(state, payload) {
      state.processing = payload
    },
    SET_ERROR(state, payload) {
      state.error = payload
    },
    CLEAN_ERROR(state) {
      state.error = null
    },
    SET_BANKS_LIST(state, payload) {
      state.banksList = payload

    },
    SET_BANKS_LIST_LOADING(state, payload) {
      state.banksListLoading = payload
    }
  },
  actions: {
    async SEND_STATISTIC() {
      const data = await sendRequestProtocols(`sendStatistic`)
      return data
    },
    async GET_BANKS_LIST({ commit }) {
      try {
        commit('SET_BANKS_LIST_LOADING', true)
        const { data } = await sendRequest('banks', 'GET')
        commit('SET_BANKS_LIST', data.filter(item => item.active === 1).map(item => {
          item.mailing = item.mailing === 1 ? true : false
          return item
        }))
        return data
      } finally {
        commit('SET_BANKS_LIST_LOADING', false)
      }
    },
    async SET_BANKS_LIST({ getters, commit }) {
      try {
        commit('SET_BANKS_LIST_LOADING', true)
        const payload = getters.getBanksList
        const { data } = await sendRequest('banks', 'PUT', payload)
        commit('SET_BANKS_LIST', data.filter(item => item.active === 1).map(item => {
          item.mailing = item.mailing === 1 ? true : false
          return item
        }))
      } finally {
        commit('SET_BANKS_LIST_LOADING', false)
      }
    }
  },
  getters: {
    getProcessing: (state) => state.processing,
    getError: (state) => state.error,
    getDebug: (state) => state.debug,
    getBanksList: (state) => state.banksList,
    getBanksListLoading: (state) => state.banksListLoading
  }
}
